import { z } from 'zod';
import { salesOrderLineChangesInputSchema, salesOrderLineShortfallChoiceSchema, } from './line-change-set-input.js';
/** Review Changes' form: the API's own reason rule, so the cap, trim and blank-as-none match. */
export const salesOrderLineChangesReviewFormSchema = salesOrderLineChangesInputSchema
    .pick({ reason: true })
    .extend({
    // One per short line the preview returned, keyed by line id or client key; null is Decide at shipment.
    shortfallChoices: z.array(z.object({
        key: z.string().min(1),
        shortfallResolutionId: salesOrderLineShortfallChoiceSchema.nullable(),
    })),
});
export const SALES_ORDER_LINE_CHANGES_REVIEW_FORM_DEFAULTS = {
    reason: '',
    shortfallChoices: [],
};
//# sourceMappingURL=line-changes-review-form.js.map